<template>
  <div class="collection">
    <div class="orderLeft">
      <el-autocomplete
        v-model="keyName"
        :fetch-suggestions="querySearchAsync"
        placeholder="输入商品/套盒名称"
        @select="handleSelect"
        style="width: 50%;margin:0 15px 0 25%"
      >
        <i class="el-icon-search el-input__icon" slot="suffix"></i>
        <template slot-scope="{ item }">
          <span class="name" v-if="leftTabType === 'proSale'">{{ item.productName }}</span>
          <span class="name" v-else>{{ item.serviceName }}</span>
        </template>
      </el-autocomplete>
      <el-button class="searchBtn" @click="search()" v-loading.fullscreen.lock="fullscreenLoading"></el-button>
      <el-tabs tab-position="left" class="tabList" v-model="leftTabType" @tab-click="handleClick">
        <el-tab-pane
          v-for="i in leftTab[$store.state.userInfo.brandId]"
          :key="i.type+'dataList'"
          :label="i.name"
          :name="i.type"
        >
          <dataList
            :leftTabType="leftTabType"
            :tabData="restaurants"
            @chooseData="chooseData"
            @refreshData='search'
            :curchooseAll="listDataAll"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="orderRight">
      <div class="settlement">
        <div class="topTit dark">
          <el-row>
            <el-col :span="11">销售员
              <el-select
                v-model="saleMen"
                placeholder="请选择销售员"
                style="width:132px;"
              >
                <el-option
                  v-for="(i,index) in staffList"
                  :label="i.staffName"
                  :value="i.staffId"
                  :key="index"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="9">
              应收
              <span class="price">¥ {{total}}</span>
            </el-col>
            <el-col :span="4">
              <el-button :class="(!saleMen || !memsFlag) ? 'greyBtn':'redBtns'" @click="payFee">
                <b>结算</b>
              </el-button>
            </el-col>
          </el-row>
        </div>
        <div class="orderContent">
          <el-input
            v-model="memtel"
            autocomplete="off"
            placeholder="输入会员手机号/姓名"
            @keyup.enter.native="specialCharacter"
            style="width: 70%;margin:0 15px"
          ></el-input>
          <el-button class="searchBtn" @click="searchTel"></el-button>
          <el-row class="memInfos">
            <el-col :span="8">
              会员姓名&nbsp;
              <span class="grey" v-if="!memInfo">--</span>
              <span class="red" v-else>{{memInfo.name}}</span>
            </el-col>
            <el-col :span="7">
              可用积分&nbsp;
              <span class="grey" v-if="!memInfo">--</span>
              <span
                class="red"
                v-else
              >{{(memInfo.accountOffList&&memInfo.accountOffList[0]&&memInfo.accountOffList[0].pointsOff && memInfo.accountOffList[0].consumedPointsOff) ? (memInfo.accountOffList[0].pointsOff - memInfo.accountOffList[0].consumedPointsOff) : '0'}}</span>
            </el-col>
            <el-col :span="9">
              充值账户&nbsp;
              <span
                class="red"
              >¥{{memInfo.accountOffList&&memInfo.accountOffList[0] ? memInfo.accountOffList[0].rechargeOff.toFixed(2) : '0.00'}}</span>
            </el-col>
          </el-row>
          <el-row class="memInfos">
            <el-col :span="8">
              赠送账户&nbsp;
              <span
                class="red"
              >¥{{memInfo.accountOffList&&memInfo.accountOffList[0] ? memInfo.accountOffList[0].giftOff.toFixed(2) : '0.00'}}</span>
            </el-col>
            <el-col :span="7">
              返现账户&nbsp;
              <span
                class="red"
              >¥{{memInfo.accountOffList&&memInfo.accountOffList[0] ? memInfo.accountOffList[0].backOff.toFixed(2): '0.00'}}</span>
            </el-col>
            <el-col :span="9">
              手机号&nbsp;
              <span
                class="red"
              >{{memInfo.phone?memInfo.phone:'--'}}</span>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="settlement serviceList">
        <div class="topTit">
          <el-row>
            <el-col :span="8">服务名称</el-col>
            <el-col :span="4">数量</el-col>
            <el-col :span="4">单价</el-col>
            <el-col :span="4">小计</el-col>
            <el-col :span="4"></el-col>
          </el-row>
        </div>
        <div class="space" style="height:15px"></div>
        <div class="serviceContent">
          <template v-if="listData.length > 0">
            <el-row class="list" v-for="(i,index) in listData" :key="index">
              <el-col :span="8">
                <el-popover trigger="hover" placement="top" v-if="(i.addType == 4 && i.packageNumberSelect > 0 ) || (i.addType != 4 && i.packageNumberSelect > 0 && i.packageNumberSelect < i.serviceSub.length)">
                  {{i.totalName}}
                  <span slot="reference" class="serviceName">{{i.totalName}}</span>
                </el-popover>
                <el-popover trigger="hover" placement="top" v-else>
                  {{i.serviceName?i.serviceName:i.totalName}}
                  <span slot="reference" class="serviceName">{{i.serviceName?i.serviceName:i.totalName}}</span>
                </el-popover>
              </el-col>
              <el-col :span="4">
                <el-input-number size="small" autocomplete="off" v-model="i.saleNumber" :min="1" :max="i.maxStock" @change="computedTotalMoney"></el-input-number>
              </el-col>
              <el-col :span="4">
                <span>{{i.salePrice?Number(i.salePrice).toFixed(2):Number(i.originalPrice).toFixed(2)}}</span>
              </el-col>
              <el-col :span="4">
                <span class="subTotal">{{i.salePrice?(i.salePrice*i.saleNumber).toFixed(2):(i.originalPrice*i.saleNumber).toFixed(2)}}</span>
                <!-- <el-button size="mini" class="greenBtn" @click="remove(index)">移除</el-button> -->
              </el-col>
              <el-col :span="4">
                <!-- <span class="subTotal">{{i.originalPrice*i.saleNumber}}</span> -->
                <el-button size="mini" class="greenBtn" @click.native="remove(index)">移除</el-button>
              </el-col>
            </el-row>
          </template>
          <el-row class="list" v-else>
            <el-col :span="8">
              <span class="grey">--</span>
            </el-col>
            <el-col :span="4">
              <span class="grey">--</span>
            </el-col>
            <el-col :span="4">
              <span class="grey">--</span>
            </el-col>
            <el-col :span="4">
              <span class="grey">--</span>
            </el-col>
            <el-col :span="4">
              <span class="grey"></span>
            </el-col>
          </el-row>
        </div>
        <div class="space" style="height:15px"></div>
        <div class="details">
          <el-row>
            <el-col :span="14">&nbsp;</el-col>
            <el-col :span="10">
              折扣&nbsp;&nbsp;
              <span :class="{'grey' : discountMoney == 0}">- ¥ {{discountMoney}}</span>&nbsp;&nbsp;
              <span class="red" :class="{'grey' : discountNum == 0}">{{discountNum}}折</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">&nbsp;</el-col>
            <el-col :span="10">
              抹零&nbsp;&nbsp;
              <span :class="{'grey' : oddsalesNumber == 0}">- ¥ {{oddsalesNumber}}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">&nbsp;</el-col>
            <el-col :span="10">
              优惠&nbsp;&nbsp;
              <span :class="{'grey' : feeNumber == 0}">- ¥ {{feeNumber}}</span>
            </el-col>
          </el-row>
        </div>
        <div class="totalPay">
          <el-row>
            <el-col :span="12">
              <span>
                总计&nbsp;&nbsp;
                <span class="total" :class="{'grey' : totalNum==0}">{{totalNum}}</span>&nbsp;&nbsp;项
              </span>
            </el-col>
            <el-col :span="12" class="cost">
              <span>
                合计&nbsp;&nbsp;
                <span class="red" :class="{'grey' : totalNum==0}">¥ {{total}}</span>
              </span>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="operation">
      <el-button class="discount returnGoods" @click="returnGoods">退货</el-button>
      <el-button class="discount feepick" @click="feepick">优惠</el-button>
      <el-button class="discount" @click="forsale">打折</el-button>
      <el-button class="discount noCount" @click="noCount">抹零</el-button>
      <el-button class="discount post" @click="onPost" :disabled="!saleMen || !memsFlag">挂单</el-button>
      <el-button class="discount postList" @click="onPostList">挂单列表</el-button>
    </div>
    <!-- 弹窗 -->
    <el-dialog
      :title="dialogType === 1 ? '支付方式':(dialogType === 2 ? '打折':(dialogType === 3 ? '抹零':(dialogType === 4 ?'挂单列表':'优惠')))"
      class="dialogOperaVisible"
      :visible.sync="dialogTableVisible"
      :center="true"
      :width="dialogType === 4 ? '1000px':'580px'"
    >
      <collectOpera :dialogType="dialogType" :memInfo="memInfo" :maxPayInfo="maxPayInfo" :transmitPost="transmitPost" @closeOpera="closeOpera" @money="chooseMoney" :feepickNum='feepickNum' :total="total" @payFeeList="payFeeList" :listGoodsId="listGoodsId" :dialogTableVisible="dialogTableVisible" :onpostFlag="onpostFlag" />
    </el-dialog>
    <el-dialog title="会员列表" :visible.sync="dialogMemVisible" :center="true" width="380px">
      <el-radio-group v-model="memCurName">
        <el-radio v-for="(i,index) in memInfoList" :label="i.memberId" :key="index"  @change="chooseMem(i)" style="width:100%;line-height:30px">{{i.name+'&nbsp;&nbsp;&nbsp;'+i.phone}}</el-radio>
      </el-radio-group>
    </el-dialog>

    <!-- 退货 -->
    <el-dialog :visible.sync="dialogReturnVisible" :center="true" width="580px" class="returnList">
      <returnGood @toMemListDialog='toMemListDialog' :moneyReturnform='moneyReturnform' :dialogReturnVisible='dialogReturnVisible' @toPwdsDialog='toPwdsDialog'></returnGood>
    </el-dialog>

    <el-dialog title="会员密码输入" :visible.sync="dialogPasswordVisible" :center="true" width="480px" v-if="dialogPasswordVisible">
      <el-form ref="pasWdForm" :model="pasWdForm" :rules="rules" label-width="120px">
        <el-form-item label="消费密码" prop="payPwd" :class="{'paypass':!setpayPwd.setpayPwd}">
          <el-input type="password" v-model="pasWdForm.payPwd" autocomplete="off" placeholder="请输入消费密码" style="width:180px" :disabled="setpayPwd.setpayPwd == 1 || setpayPwd.setpayPwd == 2"></el-input>&nbsp;&nbsp;<span class="forget red" @click="forgetPwd" v-if="!setpayPwd.setpayPwd">忘记密码？</span>
        </el-form-item>
        <el-form-item>
          <span class="grey" v-if="!setpayPwd.setpayPwd">请顾客输入6位数消费密码</span>
          <div class="red" v-else>会员未设消费密码&nbsp;&nbsp;&nbsp;&nbsp;<el-button type="primary" plain size="mini" round @click="toSetPwd">去设置</el-button></div>
        </el-form-item>
        <el-row v-if="erCode">
          <el-col :span="4">
            <div class="seize"></div>
          </el-col>
          <el-col :span="17">
            <el-form-item>
              <img src="../../assets/images/androidimg.png" alt="">
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="erCode">
          <el-col :span="6">
            <div class="seize"></div>
          </el-col>
          <el-col :span="18" class="scanFont">
              <p><b class="red">需顾客</b>打开憨妈妈小程序/APP的扫一扫，</p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;扫描下方二维码，点击确认即可。</p>
          </el-col>
        </el-row>
        <el-row class="setpwd-center">
          <el-button class="darkBtn" @click="cancelSetpwd">取消</el-button>
          <el-button class="redBtn" @click="submitPwd">提交</el-button>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 设置消费密码 -->
    <el-dialog :visible.sync="dialogSetpwd" :center="true" width="800px">
        <setPwd :setpayPwd="setpayPwd" :dialogSetpwd="dialogSetpwd" @closeset="closeset"/>
    </el-dialog>

    <!-- 退款方式 -->
    <el-dialog title="退款方式" class="dialog-return-type" :visible.sync="dialogReturnType" :center="true" width="580px" v-if="dialogReturnType">
      <returnMoneySum :memInfo='returnMoneyData' :dialogReturnType='dialogReturnType' @closeOpera='cancelSetpwd' @successReturn='successReturn' />
    </el-dialog>

  </div>
</template>
<script>
import dataList from "./dataList";
import collectOpera from './collectOpera';
import returnGood from './returnGood';
import returnMoneySum from './returnMoneySum'
import setPwd from '@/components/basicDataCenter/setPsd'
import CryptoJS from 'crypto-js'
import { searchServiceVoucher, querySaleProductList, allServiceSubList, queryMemberOfflineForSearch, allStaff, insertRestOrder, checkMemAccountPwd } from "@/api";

export default {
  name: "collection",
  components: {
    dataList, collectOpera, returnGood, setPwd, returnMoneySum
  },
  props:['memsInfo'],
  data() {
    // 密码
    var validatePass = (rule, value, callback) => {
      var reg = /^\+?[0-9][0-9]*$/;
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (!reg.test(value)) {
        callback(new Error("密码格式为数字，请设置正确格式的密码"));
      // } else if (value.length < 6) {
      //   callback(new Error("密码太短"));
      } else if (value.length > 6) {
        callback(new Error("密码长度只可以是6位"));
      } else {
        callback();
      }
    };
    return {
      fullscreenLoading: false,
      keyName: "",
      saleMen: "",
      memtel: "",
      memInfo:'',
      restaurants:[],
      dialogTableVisible:false,
      dialogMemVisible:false,
      dialogType:'',
      listData:'',
      listDataAll:[],
      discountNum:0,
      oddNumber:0,
      feepickNum:0,
      leftTab:{
        1:[
          {name:'单次服务',type:'1'},{name:'整套服务',type:'2'},{name:'零售商品',type:'10'},{name:'体验券',type:'4'},{name:'任选套餐',type:'9'},{name:'组合套餐',type:'3'},{name:'次卡',type:'6'},{name:'时卡',type:'7'}],
        2:[
          {name:'单次服务',type:'1'},{name:'整套服务',type:'2'},{name:'零售商品',type:'10'},{name:'体验券',type:'4'},{name:'任选套餐',type:'9'},{name:'组合套餐',type:'3'},{name:'次卡',type:'6'},{name:'时卡',type:'7'}],
        3:[
          {name:'单次服务',type:'1'},{name:'整套服务',type:'2'},{name:'零售商品',type:'10'},{name:'体验券',type:'4'},{name:'任选套餐',type:'9'},{name:'组合套餐',type:'3'},{name:'次卡',type:'6'},{name:'时卡',type:'7'}],
      },
      leftTabType:'4',
      staffList:'',
      memsFlag:false,//是否搜过会员
      listGoodsId:'',//挂单列表选中结算的id
      onpostFlag:'post',//是否重新挂过单
      memInfoList:[],
      memCurName:'',
      curTotalMoney:0,//应付总价格
      dialogReturnVisible:false,//退货退款弹框
      returnType:1,//会员列表，1默认是收银台类型，2是退货类型
      moneyReturnform:'',//传递会员数据到退货
      pasWdForm:{
        payPwd:''
      },
      rules:{
        payPwd:[
          { required: true, message: "请输入消费密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur"}
        ],
      },
      setpayPwd:{
        setpayPwd:0
      }, //未设置消费密码
      erCode:false,
      dialogSetpwd:false,
      dialogPasswordVisible:false,
      dialogReturnType:false,
      returnMoneyData:{},
      maxPayInfo:{
        discountNum:0,
        oddsalesNumber:0,
        feeNumber:0
      }//存储当前的折扣，优惠，抹零信息
    };
  },
  mounted() {
      this.loadAll();
      this.searchStaff();
      this.listGoodsId = '';
      if(this.memsInfo){
        this.memtel = this.memsInfo.split('?')[0];
        this.searchTel()
      }
  },
  activated() {
    this.loadAll();
    this.searchStaff();
    if(this.memsInfo){
      this.memtel = this.memsInfo.split('?')[0];
      this.searchTel()
    }
  },
  watch: {
      memsInfo(val){
          this.memtel = this.memsInfo.split('?')[0];
          this.searchTel()
      },
      '$store.state.userInfo.storeCode'(){
        this.leftTabType = '4';
        // this.loadAll();
        // this.searchStaff();
        this.listGoodsId = '';
        this.listData = [];
        this.listDataAll = [];
        this.memInfo = '';
        this.memtel ='';
        this.discountNum = 0;
        this.oddNumber = 0;
        this.feepickNum = 0;
        this.memsFlag = false;
        this.saleMen = '';
      }
  },
  computed: {
      totalNum(){
          return this.listData.length
      },
      totalQuantity(){
          let total  = 0;
          for(let i of this.listData){
              total += Number(i.saleNumber);
          }
          return total
      },
      total:{
        // 页面展示价格
        get(){
          if(this.discountNum > 0 || this.oddNumber > 0 || this.feepickNum > 0){
            this.curTotalMoney = this.curTotalMoney;
          } else {
            this.curTotalMoney = this.nowDiscountTotal(this.orderGoodsList);
          }
          return this.curTotalMoney
        },
        set(newVal){
          this.curTotalMoney = newVal;
        }
      },
      discountMoney(){
        if(this.total){
          // nofloatDiscoutPrice:0,//默认0 折扣系数相对价格
          let total = 0;
          for(let i of this.orderGoodsList){
            total += (i.nofloatDiscoutPrice*i.originalPrice)*i.saleNumber
          }
          return Number(total).toFixed(2)
        }
      },
      accurateZeroCent(){
        // 页面小计
        if(this.total){
          let total = 0;
          for(let i of this.orderGoodsList){
            total += i.salePrice*i.saleNumber
          }
          return Number(total).toFixed(2)
        }
      },
      feeNumber(){
        if(this.total){
          // nofloatforSalePrice:0,//默认0 优惠系数相对价格
          let total = 0;
          for(let i of this.orderGoodsList){
            total += (i.nofloatforSalePrice*i.originalPrice)*i.saleNumber
          }
          return Number(total).toFixed(2)
        }
      },
      oddsalesNumber(){
        if(this.total){
          // nofloatsSmallsPrice:0,//默认0 抹零系数相对价格
          let total = 0;
          for(let i of this.orderGoodsList){
            total += (i.nofloatsSmallsPrice*i.originalPrice)*i.saleNumber
          }
          return Number(total).toFixed(2)
        }
      },
      discountTotal(){
        //优惠前的价格
        let total = 0;
        for(let i of this.listData){
            total += Number(i.originalPrice*i.saleNumber);
        }
        return total.toFixed(2)
      },
      nowDiscountTotal(){
        // 现价
        return function(val){
          let total = 0;
          for(let i of val){
            total += (i.nofloatPrice)*i.saleNumber
          }
          return total.toFixed(2)
        }
      },
      orderGoodsList(){
        //购买商品列表
        let goodsLists = [];
        for(let i of this.listData){
          let subGoods=[];
          if(!i.serviceId){
            subGoods = i.orderGoodsDetailsList?i.orderGoodsDetailsList:[];
          }else{
            if((i.addType == 4 && i.packageNumberSelect > 0 ) || (i.addType != 4 && i.packageNumberSelect > 0 && i.packageNumberSelect < i.serviceSub.length)){
              for(let m of i.orderGoodsList){
                subGoods.push({
                  goodsFatherId:i.serviceId,
                  goodsId:m
                })
              }
            }else{
              if(i.serviceSub.length >0){
                for(let m of i.serviceSub){
                  subGoods.push({
                    goodsFatherId:i.serviceId,
                    goodsId:m.serviceId
                  })
                }
              }else{
                subGoods.push({
                  goodsFatherId:i.serviceId,
                  goodsId:i.serviceId
                })
              }
            }
          }
          goodsLists.push({
            goodsId:i.serviceId?i.serviceId:i.goodsId,
            originalPrice:i.originalPrice,
            salePrice:Number(i.salePrice),//现价
            nofloatPrice:Number(i.nofloatPrice),//未保留两位小数的现价
            nofloatDiscoutPrice:Number(i.nofloatDiscoutPrice?i.nofloatDiscoutPrice:0),//默认0 折扣系数相对价格
            nofloatsSmallsPrice:Number(i.nofloatsSmallsPrice?i.nofloatsSmallsPrice:0),//默认0 抹零系数相对价格
            nofloatforSalePrice:Number(i.nofloatforSalePrice?i.nofloatforSalePrice:0),//默认0 优惠系数相对价格
            saleNumber:i.saleNumber,
            orderGoodsDetailsList:subGoods,
            totalName:((i.addType == 4 && i.packageNumberSelect > 0 ) || (i.addType != 4 && i.packageNumberSelect > 0 && i.packageNumberSelect < i.serviceSub.length)) ? i.totalName:(i.totalName?i.totalName:i.serviceName),
            goodsType:i.goodsType ? i.goodsType : '2',
            goodsName:i.serviceName,
            addType:i.addType
          })
        }
        this.total = this.nowDiscountTotal(goodsLists);
        let nowtotal = 0;
        for(let i of goodsLists){
          nowtotal += i.salePrice*i.saleNumber
        }
        if(this.computedMoney(nowtotal) != this.nowDiscountTotal(goodsLists)){
          // 关于一分钱的精准度
          let curPrice = goodsLists[0];
          curPrice.salePrice = (curPrice.salePrice*curPrice.saleNumber - Number(this.computedMoney(nowtotal)-this.total))/curPrice.saleNumber;
          this.listData[0].salePrice = curPrice.salePrice
        }
        return goodsLists;
      },
      computedMoney(){
        return function (money){
          let nowmoney = money;
          return (nowmoney*100000/100000).toFixed(2);
        }
      },
      curSalesManName(){
        let name = '';
        for(let i of this.staffList){
          if(i.staffId === this.saleMen){
            name = i.staffName;
          }
        }
        return name;
      },
      transmitPost(){
        //结算的时候传递的参数
        let post={
          memberId:this.memInfo.memberId,
          memberName:this.memInfo.name,
          memberTelephone:this.memInfo.phone,
          salesmanId:this.saleMen,
          salesmanName:this.curSalesManName,
          // saleNum:this.totalQuantity,//销售数量
          amountReceivable:this.total,
          discount:Number(this.discountMoney)+Number(this.feeNumber),//=折扣价格+优惠价格
          cutSmallChange:this.oddNumber,
          orderGoodsList:this.orderGoodsList
        }
        return post;
      },
  },
  methods: {
    specialCharacter() {
      this.memtel = this.memtel.replace(
        /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im,
        ""
      );
      this.searchTel()
    },
    searchStaff(){
      allStaff({
        status:'1',
        staffType:'1',
        deleteFlag:'0'
      }).then(res=>{
        this.staffList = res.data;
      })
    },
    loadAll() {
      if(this.leftTabType === 'proSale'){
        this.restaurants = [];
        querySaleProductList({
          productName:this.keyName
        }).then(res => {
          this.restaurants = res.data;
        });
      }else{
        this.restaurants = [];
        allServiceSubList({
          addType:this.leftTabType,
          serviceName:this.keyName,
          // brandId:'1'
        }).then(res => {
          this.restaurants = res.data;
        });
      }
    },
    querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;
      this.keyName = this.keyName.replace(
        /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im,
        ""
      );
      queryString = this.keyName;
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 1000 * Math.random());
    },
    createStateFilter(queryString) {
      queryString = this.keyName;
      return state => {
        if(this.leftTabType === 'proSale'){
          return state.productName.indexOf(queryString) !== -1;
        }else{
          return state.serviceName.indexOf(queryString) !== -1;
        }
      };
    },
    handleSelect(item) {
      // 选择下拉内容
      if(this.leftTabType === 'proSale'){
        this.keyName = item.productName;
      }else{
        this.keyName = item.serviceName;
      }
    },
    search(){
      this.loadAll();
    },
    searchTel(){
      // if(/^1[3456789]\d{9}$/.test(this.memtel) === false) return;
      if(!this.memtel){
        this.$confirm( '请先输入会员手机号/姓名再查询！', "提示", {
            showCancelButton: false,
            type: "warning"
        })
        return;
      }
      queryMemberOfflineForSearch({
        keyword:this.memtel
      }).then(res=>{
        if(res.code == 0){
            this.$confirm( '查不到该会员信息，请检查手机号/姓名输入是否有误', "提示", {
                distinguishCancelAndClose: true,
                confirmButtonText: '知道了',
                showCancelButton:false,
                type: "warning"
            })
            .then(() => {})
            .catch(action => {});
            this.memsFlag = false;
        }else{
          if(res.data.length > 0){
            // 多条查询记录
            this.returnType = 1;
            this.memInfoList = res.data;
            this.dialogMemVisible = true;
          }else{
            this.memInfo = res.data;
            this.memsFlag = true;
          }
        }
      })
    },
    toMemListDialog(val){
      this.returnType = 2;
      this.dialogMemVisible = val.dialog;
      this.memInfoList = val.data;
    },
    chooseMem(val){
      queryMemberOfflineForSearch({
        keyword:val.phone
      }).then(res=>{
        if(this.returnType == 1){
          this.dialogMemVisible = false;
          this.memsFlag = true;
          this.memInfo = res.data;
        } else {
          this.dialogMemVisible = false;
          this.moneyReturnform = res.data;
          this.selectPwd(res.data)
        }
      })
    },
    selectPwd(val){
      this.setpayPwd.memberId = val.memberId;
      if (!val.accountOffList || val.accountOffList.length == 0) {
        // 提交后先走接口1（加入本店会员） 再走接口2（更新会员消费密码）
        this.setpayPwd.setpayPwd = 2;
      } else if(val.accountOffList[0].passwordOff == 0){
        // 提示去设置密码，提交后走更新会员消费密码接口（updateMemberOffPassword）
        this.setpayPwd.setpayPwd = 1;
      }else{
        this.setpayPwd.setpayPwd = 0;
      }
    },
    forgetPwd(){
      // 展开下面二维码
      this.erCode = true;
    },
    toPwdsDialog(val){
      // this.dialogPasswordVisible = val.show;
      this.dialogReturnType = val.show;
      this.returnMoneyData.type = val.type;
      this.returnMoneyData.data = val.data;
      this.moneyReturnform = val.data;//传递会员数据

      this.returnType = 2;
      this.chooseMem(this.moneyReturnform)

      // this.pasWdForm.payPwd = '';
      // this.$nextTick(()=>{
      //   this.$refs.pasWdForm.resetFields()
      // })
    },
    toSetPwd(){
      // 去设置密码
      this.dialogSetpwd = true;
      this.dialogPasswordVisible = false;
    },
    closeset(val){
      // 密码设置完成
      this.returnType = 2;
      this.chooseMem(this.moneyReturnform)
      this.dialogSetpwd = val;
      this.dialogPasswordVisible = true;
    },
    cancelSetpwd(){
      this.dialogReturnType = false;
      this.dialogPasswordVisible = false;
      this.$message({
          type: "info",
          message: "已取消"
      });
    },
    successReturn(){
      this.dialogReturnType = false;
      this.dialogPasswordVisible = false;
      this.dialogReturnVisible = false;
    },
    operaEntryDES(message) {
      var keyHex = CryptoJS.enc.Utf8.parse("VIP20198888*7*6*5*4**88882088VIP");
      var encrypted = CryptoJS.TripleDES.encrypt(message, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    submitPwd(){
      this.$refs.pasWdForm.validate(valid => {
          if (valid) {
            checkMemAccountPwd({
              memberId:this.moneyReturnform.memberId,
              passwordOff:this.operaEntryDES(this.pasWdForm.payPwd)
            }).then(res=>{
              if(res.code == 1){
                // 退款方式
                this.dialogPasswordVisible = false;
                this.dialogReturnType = true;
              }else{
                this.$message({
                  message: res.msg,
                  type: "error"
                });
              }
            })
          }else{
            console.log("error submit!!");
            return false;
          }
      })
    },
    handleClick(tab){
      this.loadAll();
    },
    payFee(){
        // 结算
        if(!this.saleMen){
            this.$confirm( '销售员不可为空', "提示", {
                distinguishCancelAndClose: true,
                confirmButtonText: '知道了',
                showCancelButton:false,
                type: "warning"
            })
            .then(() => {})
            .catch(action => {});
        }else if(!this.memsFlag){
          this.$confirm( '会员不可为空', "提示", {
              distinguishCancelAndClose: true,
              confirmButtonText: '知道了',
              showCancelButton:false,
              type: "warning"
          })
          .then(() => {})
          .catch(action => {});
        }else if(this.listData.length == 0){
          this.$confirm( '请选择服务！', "提示", {
              showCancelButton: false,
              type: "warning"
          })
        }else if(this.feeNumber > this.$store.state.userInfo.maxPreferential){
          // 超过最大优惠
          this.$confirm( '已超过最大优惠额度，请重新设置优惠！', "提示", {
              showCancelButton: false,
              type: "warning"
          })
        }else if(this.oddsalesNumber > this.$store.state.userInfo.maxMaling){
          // 超过最大抹零
          this.$confirm( '已超过最大抹零额度，请重新设置抹零！', "提示", {
              showCancelButton: false,
              type: "warning"
          })
        }else {
            this.dialogTableVisible = true;
            this.dialogType = 1;
        }
    },
    returnGoods(){
      // 退货
      this.dialogReturnVisible = true;
    },
    forsale(){
        // 打折
        if(this.listData.length > 0){
          // 把需要的信息传到弹框上，折扣
          this.maxPayInfo.discountNum = this.discountNum
          this.dialogTableVisible = true;
          this.dialogType = 2;
        }else{
          this.$confirm( '请先选择服务！', "提示", {
              showCancelButton: false,
              type: "warning"
          })
        }
    },
    feepick(){
      if(this.listData.length > 0){
        // 把需要的信息传到弹框上，优惠
        this.maxPayInfo.feeNumber = this.feeNumber
        this.dialogTableVisible = true;
        this.dialogType = 5;
      }else{
        this.$confirm( '请先选择服务！', "提示", {
            showCancelButton: false,
            type: "warning"
        })
      }
    },
    noCount(){
      if(this.listData.length > 0){
        // 把需要的信息传到弹框上，抹零
        this.maxPayInfo.oddsalesNumber = this.oddsalesNumber
        this.dialogTableVisible = true;
        this.dialogType = 3;
      }else{
        this.$confirm( '请先选择服务！', "提示", {
            showCancelButton: false,
            type: "warning"
        })
      }
    },
    onPost(){
        // 挂单
        if(this.listData.length > 0){
          this.transmitPost.storeListDataAll = this.listDataAll;
          this.transmitPost.discountNum = this.discountNum;
          this.transmitPost.feepickNum = this.feepickNum;
          insertRestOrder({
            rest: JSON.stringify(this.transmitPost)
          }).then(res=>{
            if(res.code == 1){
              this.$confirm( '此订单将被暂存到“挂单列表”中~', "挂单", {
                  distinguishCancelAndClose: true,
                  confirmButtonText: '确定',
                  showCancelButton:false,
                  type: "success"
              })
              .then(() => {
                  this.listData = [];
                  this.listDataAll = [];
                  this.memInfo = '';
                  this.memtel ='';
                  this.discountNum = 0;
                  this.oddNumber = 0;
                  this.feepickNum = 0;
                  this.memsFlag = false;
                  this.saleMen = '';
                  this.onpostFlag = this.onpostFlag + new Date().getTime();
              })
              .catch(action => {});
            }
          })
        }else{
          this.$confirm( '请先选择服务！', "提示", {
              showCancelButton: false,
              type: "warning"
          })
        }

    },
    onPostList(){
        // 挂单列表
        this.dialogTableVisible = true;
        this.dialogType = 4;
    },
    chooseData(data){
        this.listData = data.chooseData;
        this.listDataAll = data;

      // 商品数量增加 优惠和抹零不变
      // 重新计算
      this.computedTotalMoney();
    },
    computedTotalMoney(){
      // 商品数量增加 优惠和抹零不变
      // 重新计算
      this.dialogType = 3;
      this.chooseMoney(this.oddNumber)
      this.$nextTick(()=>{
        this.dialogType = 5;
        this.chooseMoney(this.feepickNum)
      })
    },
    remove(index){
        // 移除
        this.listData = this.listDataAll.chooseData;
        this.listDataAll.chooseId.splice(index,1);
        this.listData.splice(index,1);
        this.discountNum = this.discountMoney>0?this.discountNum:0;

        // 重新计算
        this.computedTotalMoney();

        this.oddNumber = this.oddsalesNumber;

        if(this.listData.length == 0){
          // 购物单全都没了后清零
          this.discountNum = 0;
          this.oddNumber = 0;
          this.feepickNum = 0;
          this.listData = [];
          this.listDataAll = [];
        }
    },
    closeOpera(val){
        // 关闭弹窗
        if(val == 'removeOprea'){
          // 创建订单成功后清空购物车
          this.dialogType = 1;
          this.dialogTableVisible = false;
          for(let i of this.listData){
            i.salePrice = 0;
            i.nofloatPrice = 0;
            i.nofloatDiscoutPrice = 0;
            i.nofloatsSmallsPrice = 0;
            i.nofloatforSalePrice = 0;
          }
          this.listData = [];
          this.listDataAll = [];
          this.memInfo = '';
          this.memtel ='';
          this.discountNum = 0;
          this.oddNumber = 0;
          this.feepickNum = 0;
          this.memsFlag = false;
        }else{
          this.dialogTableVisible = val;
        }
    },
    chooseMoney(val){
        // nofloatDiscoutPrice:0,//默认0 折扣系数相对价格
        // nofloatsSmallsPrice:0,//默认0 抹零系数相对价格
        // nofloatforSalePrice:0,//默认0 优惠系数相对价格
        if(this.dialogType === 2){
            for(let i of this.orderGoodsList){
              // 折上折，不做重置操作
              let price = i.nofloatPrice;//折扣前的单价
              i.salePrice = this.computedMoney(i.nofloatPrice);
              if(i.nofloatPrice != 0){
                i.nofloatPrice = i.nofloatPrice*(val/10);
                i.nofloatDiscoutPrice = (price - i.nofloatPrice)/i.originalPrice;
              };
            }
            this.computedNextMoney(this.orderGoodsList);
          this.discountNum = this.discountNum>0?(this.discountNum*val/10).toFixed(2):val;
        }else if(this.dialogType === 3){
          // if(!this.oddNumber || this.oddNumber != Number(val)){
            let nowToprice = Number(this.discountTotal) - Number(this.discountMoney) - Number(this.feepickNum) - Number(val);//现价
            for(let i of this.orderGoodsList){
              let price = i.nofloatPrice;//抹零前的单价
              i.salePrice = this.computedMoney(i.nofloatPrice);
              if(i.nofloatPrice != 0){
                i.nofloatPrice = (((i.nofloatPrice*i.saleNumber)/this.total)*nowToprice)/i.saleNumber;
                i.nofloatsSmallsPrice = i.nofloatPrice ? (i.nofloatPrice/nowToprice*val)/i.originalPrice : price/i.originalPrice;
              };
            }
          // }
          this.computedNextMoney(this.orderGoodsList);
          this.oddNumber = Number(val).toFixed(2);
        }else{
          let huitotal = Number(this.discountTotal) - Number(this.discountMoney) - Number(this.oddNumber) - Number(val);//现价
          // if(!this.feepickNum || this.feepickNum !== discount){
            for(let i of this.orderGoodsList){
              let price = i.nofloatPrice;//优惠前的单价              
              i.salePrice = this.computedMoney(i.nofloatPrice);             
              if(i.nofloatPrice != 0){
                i.nofloatPrice = ((((i.nofloatPrice*i.saleNumber)/this.total)*huitotal)/i.saleNumber);
                i.nofloatforSalePrice = i.nofloatPrice ? (i.nofloatPrice/huitotal*val)/i.originalPrice : price/i.originalPrice;
              };
            }
          // }
          this.computedNextMoney(this.orderGoodsList);
          this.feepickNum = Number(val).toFixed(2);
        }
    },
    computedNextMoney(list){
      this.$nextTick(()=>{
          this.total = this.nowDiscountTotal(list);
          if(this.accurateZeroCent != this.total){
            // 关于一分钱的精准度
            let curPrice = list[0];
            curPrice.salePrice = (curPrice.salePrice*curPrice.saleNumber - Number(this.accurateZeroCent-this.total))/curPrice.saleNumber
          }
          list.forEach((i,index)=>{
            this.listData[index].salePrice = i.salePrice
            this.listData[index].nofloatPrice = i.nofloatPrice
            this.listData[index].nofloatDiscoutPrice = i.nofloatDiscoutPrice
            this.listData[index].nofloatsSmallsPrice = i.nofloatsSmallsPrice
            this.listData[index].nofloatforSalePrice = i.nofloatforSalePrice
          })
        })
    },
    payFeeList(curData){
      // 挂单列表的结算
      let chooseRowData = $.extend(true,{},curData[0]);
      this.dialogTableVisible = false;
      this.saleMen = chooseRowData.salesmanId;
      this.memtel = chooseRowData.memberTelephone;
      this.searchTel();
      this.discountNum = chooseRowData.discountNum;
      this.oddNumber = chooseRowData.cutSmallChange;
      this.feepickNum = chooseRowData.feepickNum;
      this.listData = chooseRowData.orderGoodsList;
      this.listDataAll = chooseRowData.storeListDataAll;
      this.listGoodsId = chooseRowData.id;
    }
  }
};
</script>
<style>@import "../../assets/css/left.css";</style>
<style lang="less" scoped>
.grey {
  color: #999;
}
.collection {
  min-width: 1450px;
  max-width: 95%;
  margin: 25px auto 0;
  overflow: hidden;
  position: relative;
  .searchBtn {
    width: 47px;
    height: 38px;
    border: none;
    background: #f83b56 url(../../assets/images/store/btn_datalist_search.png)
      no-repeat center;
  }
  .orderLeft {
    width: 55%;
    display: inline-block;
    .tabList {
      height: 650px;
      padding-top: 20px;
      padding-right: 10px;
    }
  }
  .orderRight {
    display: inline-block;
    vertical-align: top;
    margin: 0 0 0 3%;
    width: 40%;
    max-width: 460px;
    .el-button{
      border: none;
    }
    .settlement {
      height: 220px;
      box-shadow: 0px 0px 19px 0px rgba(65, 67, 85, 0.1);
      border-radius: 10px;
      margin-bottom: 20px;
      &.serviceList {
        height: 430px;
        position: relative;
      }
    }
    .topTit {
      width: 100%;
      height: 55px;
      line-height: 55px;
      background: #2ecfa7;
      border-radius: 10px 10px 0 0;
      color: #fff;
      text-align: center;
      &.dark {
        background: #3b404f;
        .el-col-9 {
          font-weight: bold;
          .price {
            font-size: 19px;
          }
        }
        .redBtns,
        .greyBtn {
          margin-top: 9px;
          line-height: 0;
        }
      }
    }
    .orderContent {
      padding: 30px 0 30px 35px;
      .searchBtn{
        margin-right: 35px;
      }
      .el-row {
        margin-top: 20px;
      }
      .memInfos {
        .el-col {
          font-size: 12px;
          color: #666;
          span {
            &.red{
              font-size: 13px;
            }
          }
        }
      }
    }
    .serviceContent {
      height: 215px;
      overflow-y: auto;
      .list {
        height: 44px;
        line-height: 44px;
        text-align: center;
        .serviceName {
          width: 80%;
          margin: 0 auto;
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .subTotal {
          color: #666;
        }
        .greenBtn {
          width: 46px;
          text-align: center;
          padding: 8px 0;
          background: #2ecfa7;
          color: #fff;
        }
      }
    }
    .details {
      padding: 0 0 10px;
    }
    .totalPay {
      height: 60px;
      line-height: 60px;
      padding: 0 35px;
      border-top: 1px solid #e1e4e9;
      .total {
        font-weight: bold;
        font-size: 17px;
      }
      .cost {
        font-size: 15px;
        font-weight: bold;
        text-align: right;
        .red {
          font-size: 19px;
        }
      }
    }
  }
  .operation {
    width: 8%;
    min-width: 110px;
    max-width: 130px;
    position: absolute;
    top: 150px;
    right: 0;
    .discount {
      width: 100%;
      height: 46px;
      color: #fff;
      font-size: 15px;
      text-indent: 20px;
      margin: 0 0 10px 0;
      border: none;
      background: #3b404f url(../../assets/images/store/counter_dazhe.png)
        no-repeat 22px center;
      background-size: 28px;
      &.returnGoods{
        background: #3b404f url(../../assets/images/store/tuikuan.png)
          no-repeat 22px center;
        background-size: 28px;
      }
      &.feepick{
        background: #3b404f url(../../assets/images/store/youhui.png)
          no-repeat 22px center;
        background-size: 28px;
      }
      &.noCount {
        background: #3b404f url(../../assets/images/store/counter_moling.png)
          no-repeat 22px center;
        background-size: 28px;
      }
      &.post {
        background: #3b404f url(../../assets/images/store/counter_guadan.png)
          no-repeat 22px center;
        background-size: 28px;
      }
      &.postList {
        background: #ffb932
          url(../../assets/images/store/counter_guadanlist.png) no-repeat 22px
          center;
        margin-top: 30px;
      }
    }
  }
  .setpwd-center{
    text-align: center
  }
}
</style>
<style lang="less">
.el-button.redBtns,
.el-button.greyBtn {
  height: 38px;
  background: #f83b56;
  border: 1px solid #f83b56;
  font-size: 17px;
  color: #fff;
}
.el-button.greyBtn {
  background: #646b81;
  border: 1px solid #646b81;
}
.tabList {
  .el-tabs__header.is-left {
    margin-right: 0;
    .el-tabs__nav-wrap::after {
      width: 0;
    }
    .el-tabs__active-bar {
      width: 0;
    }
    .el-tabs__nav {
      margin-top: 20px;
      .el-tabs__item {
        width: 98px;
        height: 46px;
        line-height: 46px;
        background: #2ecfa7;
        border-radius: 23px 0px 0px 23px;
        color: #fff;
        font-size: 15px;
        margin-bottom: 15px;
        margin-left: 20px;
        &:hover,
        &:focus,
        &.is-active {
          width: 118px;
          margin-left: 0;
          background: #3b404f;
          font-weight: bold;
          position: relative;
          &::before {
            content: "";
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #fff;
            position: absolute;
            top: 18px;
            left: 20px;
          }
        }
      }
    }
  }
  .el-tabs__content {
    box-shadow: 0px 0px 19px 0px rgba(65, 67, 85, 0.1);
    border-radius: 19px;
  }
}
.el-input__inner {
  border-radius: 20px;
}
.serviceContent {
  .el-input__inner {
    height: 30px;
  }
  .el-input-number--small {
    width: 80px;
    line-height: 17px;
    .el-input__inner {
      padding: 0;
    }
    .el-input-number__decrease,
    .el-input-number__increase {
      width: 22px;
      height: 17px;
      border: none;
      border-radius: 8px;
      font-size: 12px;
      font-weight: bold;
      background: #e3e7f0;
      &:hover {
        color: #2ecfa7;
        background: #d1f4eb;
      }
      &.is-disabled{
        background: #eff0f3;
      }
    }
    // .el-input-number__decrease {
    //   background: #eff0f3;
    // }
    // .el-input-number__increase {
    //   background: #e3e7f0;
    // }
  }
  .el-input--small .el-input__inner {
    height: 17px;
    line-height: 17px;
    border: none;
    color: #666;
  }
}
.returnList{
  .el-dialog__header{display: none}
  .el-dialog__body{
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/operatingFloor/collection.vue